<template lang="pug">
  .container
    .columns
      .column.is-2
        .field
            label.label Marca
            .control
              typeahead(:options="marcas" :optionSelect="marcaData" :tema="typeMarca" v-model="marcaSel")
      .column.is-2
        .field
          label.label Modelo
          .control
            input.input.is-primary(
              type='text', 
              placeholder='Modelo',
              v-model="modelo",
            )
      .column.is-4
        .field
          label.label Tipo
          .control
            typeahead(:options="tipos" :optionSelect="tipoSel" :tema="typeTipos" v-model="tipoSel")
      .column.is-2
        .field
          label.label No. Parte
          .control
            input.input.is-primary(
              type='text', 
              placeholder='No. Parte',
              v-model="noParte",
            )
    .columns
      .column.is-2
        .field
          label.label Unidad de Medida
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="unidadMedida")
                option(value="1") Pieza
                option(value="2") Caja
                option(value="3") Estuche
                option(value="4") Juego
                option(value="5") Kit
                option(value="6") Paquete
                option(value="7") Metro
                option(value="8") Litro
                option(value="9") Par
                option(value="10") Galón
            .icon.is-small.is-left
              i.fas.fa-map-pin
      .column.is-2
        .field
          label.label Línea
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="lineaSel")
                option(v-for="line in lineas" :value="line") {{ line.nombre }}
            .icon.is-small.is-left
              i.fas.fa-map-pin
      .column.is-2
        .field
          label.label Detalle
          .control.has-icons-left
            .select.is-primary.is-rounded
              select(v-model="detalleSel")
                option(v-for="det in detalles" :value="det") {{ det.nombre }}
            .icon.is-small.is-left
              i.fas.fa-map-pin
      .column.is-2
        .field
          label.label Limite
          .control
            input.input.is-primary(
              type='number', 
              placeholder='1',
              min= "1",
              v-model="limite",
            )
    .columns
      .column.is-12
        a.button.is-primary.is-rounded.is-medium(:disabled="isDisabled" @click="checkForm") Guardar
    .columns(v-show="datosFaltantes.length > 0")
      .column.is-12
        .notification
          .field.is-grouped.is-grouped-multiline
            .control(v-for="datosF in datosFaltantes")
              .tags
                span.tag.is-danger.is-light {{ datosF }}
</template>

<script>
  import Typeahead from '@/components/inventario_Componentes/Typeahead.vue'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import 'flatpickr/dist/plugins/monthSelect/style.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import moment from 'moment'
  import InventarioServices from '../../services/inventario/inventario'

  export default {
    name: 'FormCons_Entrada',
    components: { Typeahead, flatPickr },
    props: {
      marcas: {
        type: Array,
        default: []
      },
      tipos: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        modelo: null,
        fechaReg: null,
        limite: null,
        unidadMedida: null,
        tipoSel: {},
        itemData: {},
        marcaSel: {},
        marcaData: {},
        noParte: '',
        typeMarca: 'marca',
        typeTipos: 'tipos',
        datosFaltantes: [],
        lineas: [
          {'id': 1, 'nombre': 'SEGURIDAD'},
          {'id': 2, 'nombre': 'EQUIPO'},
          {'id': 3, 'nombre': 'MANTENIMIENTO'},
          {'id': 4, 'nombre': 'OPERACIÓN'},
          {'id': 5, 'nombre': 'PAPELERÍA'},
          {'id': 6, 'nombre': 'REFACCIONES'},
          {'id': 7, 'nombre': 'LIMPIEZA'},
          {'id': 8, 'nombre': 'PINTURA'},
          {'id': 9, 'nombre': 'UNIFORMES'},
          {'id': 10, 'nombre': 'ENFERMERÍA'},
        ],
        lineaSel: {},
        detalles: [
          {'id': 1, 'nombre': 'CONSUMIBLE'},
        ],
        detalleSel: {},
        isDisabled: true,
      }
    },
    watch: {
      marcaSel () {
        let count = 0
        this.marcas.forEach(marca => {
          if (marca.id === this.marcaSel.id) {
            count = count + 1
          }
        })
        if (count > 0 ) {
          console.log('Si existe')
        } else {
          console.log('No existe, es nueva marca')
          //this.obtenerMarcas()
        }
      },
      tipoSel () {
        this.searchConsumibleBase()
      },

      modelo () {
        this.searchConsumibleBase()
      },
      
      marcaSel () {
        this.searchConsumibleBase()
      },
    },
    methods: {
      getTipo: function (id) {
        let result;
        let type = this.tipos.filter(tipo => tipo.id === id)
        let tipoEnc = type[0]
        if (tipoEnc.subcategoria === '') {
          result = tipoEnc.categoria
        } else {
          result = `${tipoEnc.categoria} (${tipoEnc.subcategoria})`
        }

        return result
      },

      checkForm () {
        if (this.isDisabled) {
          return
        }
        this.datosFaltantes = []
        if (Object.keys(this.marcaSel).length > 0 && this.modelo && Object.keys(this.tipoSel).length > 0 && this.unidadMedida && this.limite && Object.keys(this.lineaSel).length > 0 && Object.keys(this.detalleSel).length > 0) {
          console.log('Formulario completo')
          this.saveConsumible()
        } else {
          console.log('Faltan campos por llenar')
          
          if (!Object.keys(this.marcaSel).length > 0) {
            this.datosFaltantes.push('Debe selecionar una marca, es requida.')
          }
          
          if (!this.modelo) {
            this.datosFaltantes.push('El modelo es requido.')
          }
          
          if(!Object.keys(this.tipoSel).length > 0) {
            this.datosFaltantes.push('El Tipo de artículo es requido.')
          }
          
          if(!this.unidadMedida) {
            this.datosFaltantes.push('La unidad de medida es requida.')
          } 
          
          if(!this.limite) {
            this.datosFaltantes.push('La cantidad límite es requida.')
          } 
          
          if(!Object.keys(this.lineaSel).length > 0) {
            this.datosFaltantes.push('La Línea del consumible es requerida.')
          }

          if(!Object.keys(this.detalleSel).length > 0) {
            this.datosFaltantes.push('el Detalle del consumible es requerido.')
          }
        }
      },

      saveConsumible () {
        this.isLoading = true
        let areaINT = 0

        switch (this.tipoSel.area) {
          case 's':
            areaINT = 3
            break
          case 'i':
            areaINT = 1
            break
          case 'a':
            areaINT = 2
            break
        
          default:
            areaINT = 0
            break
        }

        let myObj = {
          marca: this.marcaSel.nombre,
          modelo: this.modelo, 
          area: areaINT, 
          id_cat: this.tipoSel.id_cat,
          categoria: this.tipoSel.categoria,
          id_subcat: this.tipoSel.id_sub,
          subcategoria: this.tipoSel.subcategoria,
          unidadMedida: Number(this.unidadMedida), 
          limite: parseInt(this.limite),
          linea: parseInt(this.lineaSel.id),
          detalle: parseInt(this.detalleSel.id),
          noParte: this.noParte,
        }
        
        this.$emit('saveForm', myObj)
        this.limpiarForm()
      },

      limpiarForm() {
        this.marcaSel = {}
        this.modelo = null
        this.tipoSel = {}
        this.unidadMedida = null
        this.limite = null
        this.lineaSel = {}
        this.detalleSel = {}
      },

      searchConsumibleBase() {
        if (Object.keys(this.tipoSel).length < 1) {
          return
        }

        if (Object.keys(this.marcaSel).length < 1) {
          return
        }

        const _modelo = this.modelo ? this.modelo : ''
        InventarioServices.buscarConsumibleBase(this.marcaSel.nombre, _modelo, this.tipoSel.id_cat, this.tipoSel.id_sub)
          .then( data => {
            const existe = parseInt(data[0].existe) == 1 ? true : false
            this.isDisabled = existe
            if (existe) {
              this.displayToast('bubble', 'Ya existe un consumible con estas características.')
            }
          })
          .catch( e => {
            this.displayToast('bubble',e.message, 'ban', 'OK')
          })
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
    },
    created () {
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/FormCons_Entrada.vue